import React, { useState } from "react";
import { Modal, ButtonWithAction, Box, util } from "@thecb/components";

const { noop } = util.general;

const RemoveAccountModalModule = ({
  agencyName,
  obligations = [],
  removeAccount,
  accountType,
  isMobile,
  disableActions = false
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const lastItem = [...obligations].pop();
  const accounts = obligations.length
    ? obligations.reduce((acc, curr) => {
        const account = curr.details.description;
        const formattedAccount =
          curr !== lastItem ? `${account} and ` : `${account}`;
        return formattedAccount === agencyName
          ? agencyName
          : acc + formattedAccount;
      }, `${agencyName} - `)
    : "";
  const identifier =
    accountType === "Account" && obligations.length > 1
      ? "accounts"
      : accountType === "Property" && obligations.length > 1
      ? "properties"
      : accountType.toLowerCase();
  const accountsText = (accounts ?? "").trim();

  return (
    <Modal
      showModal={() => setModalIsOpen(true)}
      hideModal={() => setModalIsOpen(false)}
      modalOpen={modalIsOpen}
      modalHeaderText={`Remove ${accountType}`}
      modalBodyText={`Are you sure you want to remove the ${identifier}${
        accountsText ? ` ${accountsText}` : ""
      }? Any autopay scheduled against ${
        obligations.length > 1 ? "them" : "it"
      } will be deactivated.`}
      continueButtonText="Remove"
      continueAction={() => {
        if (!disableActions) {
          removeAccount();
          setModalIsOpen(false);
        }
      }}
      useDangerButton
    >
      <Box padding="0" extraStyles={`flex-grow: 1;`}>
        <ButtonWithAction
          text="Remove"
          variant="secondary"
          action={disableActions ? noop : () => setModalIsOpen(true)}
          dataQa="Remove Account"
          extraStyles={
            isMobile ? `flex-grow: 1; width: 100%; margin: 0;` : `flex-grow: 1;`
          }
          disabled={disableActions}
        />
      </Box>
    </Modal>
  );
};
export default RemoveAccountModalModule;
